/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Číselník platforem, které se v rámci aktualizačního procesu považují za odlišné.
 * Obsahově vychází z číselníku `Platform` v `util.js`, ale zjemňuje jej
 * o informace, které se mohou měnit až po sestavení dané platformy. Jedná se
 * např. o informaci o orientaci zařízení u platformy SSSP 4. Zatímco
 * `Platform` odpovídá adresářům v `src/platform` a tedy možným čistým
 * sestavením aplikace, `UpdatePlatform` odpovídá publikovaným balíčkům,
 * tedy hodnotám v update manifestu.
 * @enum {string}
 */
const UpdatePlatform = {
  /** Platforma pro Ki-Wi Lighter API ve verzi 1. */
  KiwiLighter1: 'KiwiLighter1',
  /** Platforma pro Samsung Smart Signage Platform verze 4. */
  TizenSssp4: 'TizenSssp4',
  /** Platforma pro standardní webové technologie. */
  Web: 'Web',
  /** Platforma pro LG webOS Smart Signage Platform ve verzi 3.0. */
  WebosSignage3_0: 'WebosSignage3_0',
  /** Platforma pro LG webOS Smart Signage Platform ve verzi 3.2. */
  WebosSignage3_2: 'WebosSignage3_2'
};

export default UpdatePlatform;
